import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bb90c49"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "disabled", "data-bs-toggle", "data-bs-target"]
const _hoisted_2 = {
  key: 0,
  class: "position-absolute px-2 text-white unread-count"
}
const _hoisted_3 = {
  key: 1,
  class: "spinner-border text-secondary",
  role: "status"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1))
const _hoisted_5 = [
  _hoisted_4
]

import { computed, PropType } from 'vue'
import { numberWithCommas } from '@/constants/common.ts'
type ButtonType = 'primary' | 'secondary'
type ButtonSize = 'normal' | 'small' | 'tiny'
type ButtonHtmlType = 'button' | 'reset' | 'submit'


export default /*#__PURE__*/_defineComponent({
  props: {
  title: String,
  onClick: {
    type: Function as PropType<() => void | Promise<void> | undefined>,
  },
  type: {
    type: String as PropType<ButtonType>,
    default: 'primary',
  },
  size: {
    type: String as PropType<ButtonSize>,
    default: 'normal',
  },
  htmlType: {
    type: String as PropType<ButtonHtmlType>,
    default: 'button',
  },
  className: {
    type: String,
    default: '',
  },
  dataBsToggle: {
    type: String,
    default: '',
  },
  dataBsTarget: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  unread_count: {
    type: Number,
    default: 0,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props


const classObject = computed(() => {
  const { type, size, className, unread_count } = props
  const objClass = {
    primary: 'primary',
    secondary: 'secondary',
  }
  return `${objClass[type]} ${size} ${className} ${unread_count > 0 && 'position-relative'}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.htmlType,
    disabled: __props.disabled,
    "data-bs-toggle": __props.dataBsToggle,
    "data-bs-target": __props.dataBsTarget,
    class: _normalizeClass(['shadow', _unref(classObject), __props.disabled ? 'disabled' : '']),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.onClick && __props.onClick(...args)))
  }, [
    _createTextVNode(_toDisplayString(__props.title), 1),
    (__props.unread_count > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(numberWithCommas)(__props.unread_count)), 1))
      : _createCommentVNode("", true),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})